export type ILoginModal = {
  active: boolean
  promptActive: boolean
}
export const UpdateLoginModalAction: string = "update-login-modal-action";
